import React, { useEffect, useState } from "react";
import { InvoiceDetailStyled } from "./style";
import TransactionStatus from "../../TransactionStatus/index";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import Footer from "../../Footer";
import PowerByEpayco from "../../PowerByEpayco/index";
import TransactionService from "../../../services/transactionServices";
import { useLocation } from "react-router";
import config from "../../../config/enviroment";
import { PdfDetails } from "../../PdfDetail";
var Pdf = function () {
    var search = useLocation().search;
    var refPayco = new URLSearchParams(search).get("ref_payco");
    var invoice = useSelector(function (state) { return state.invoice; });
    var _a = useForm({ mode: "onChange" }), register = _a.register, handleSubmit = _a.handleSubmit, watch = _a.watch, errors = _a.formState.errors;
    var _b = useState({
        status: "",
        franchise: "",
        date: "",
        payment: 0,
        balance: 0,
        authorizationCode: "",
        nRef: "",
        refEpayco: "",
    }), data = _b[0], setData = _b[1];
    var transactionService = new TransactionService();
    useEffect(function () {
        if (refPayco) {
            transactionService
                .getTransaction(refPayco)
                .then(function (data) {
                setData(data);
            })
                .catch(function (e) {
            });
        }
    }, []);
    if (localStorage.getItem('typeInvoice') == 'SALES-INV') {
        data.typeInvoice = 'Factura de venta' || '';
    }
    if (localStorage.getItem('typeInvoice') == 'CYCLE-INV') {
        data.typeInvoice = 'Factura mensual' || '';
    }
    data.total = (data.balance || 0) + (data.payment || 0);
    return (React.createElement(React.Fragment, null,
        React.createElement(InvoiceDetailStyled, null,
            React.createElement("div", { style: { margin: "0 auto", width: "190px" } },
                React.createElement("img", { src: config.urlS3 + "/wom/logo.png", alt: "logo wom", style: { width: "100%" } })),
            React.createElement(TransactionStatus, { refEpayco: data.refEpayco || "", nRef: data.nRef || "", status: data.status || "", isRefLogin: (data.nRef && data.nRef.length > 10) || false }),
            React.createElement(PdfDetails, { data: data })),
        React.createElement("div", { style: { width: "100%", height: "200px" } }),
        React.createElement(PowerByEpayco, null),
        React.createElement(Footer, null)));
};
export default Pdf;
